
import Typography from '@mui/material/Typography';


export const TextDrugDoxepin = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Doxepin is a type of medicine called a tricyclic antidepressant (TCA). 
It is prescribed to treat depression and anxiety. Doxepin overdose occurs when someone takes more than the normal or 
recommended amount of this medicine, either by accident or on purpose. Toxic level of a TCA can build up in the body if the TCA and other medicines interact. 
This interaction can affect how well the body can break down the TCA.
<br /><br />
Doxepin is used to treat depression and anxiety. Doxepin is in a class of medications called tricyclic antidepressants. It works by increasing the amounts of certain natural substances in the brain that are needed for mental balance.
Doxepin is also available as a tablet to treat insomnia. This monograph only gives information about doxepin for depression or anxiety. If you are using this medication for insomnia, read the monograph entitled doxepin (insomnia).


<br /><br />



Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a682390.html

</Typography>

</div>

)
}